import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { makeObservable, observable } from 'mobx';
import FieldFilter from "./FieldFilter.js";
export class FlagFilter extends FieldFilter {
  constructor(fieldName, params) {
    var _params$mode;
    super(fieldName, _objectSpread({
      initialState: [],
      matchOnEmpty: true
    }, params));
    _defineProperty(this, "mode", void 0);
    _defineProperty(this, "options", void 0);
    makeObservable(this, {
      mode: observable,
      options: observable.deep
    });
    this.options = params.options;
    this.mode = (_params$mode = params.mode) !== null && _params$mode !== void 0 ? _params$mode : 'any';
  }
  exposeParams() {
    return _objectSpread(_objectSpread({}, super.exposeParams()), {}, {
      mode: this.mode,
      options: this.options
    });
  }
  createSnapshot() {
    var deproxyify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var superclassSnapshot = super.createSnapshot(deproxyify);
    var selfSnapshot = {
      mode: this.mode,
      options: this.options
    };
    return _objectSpread(_objectSpread({}, superclassSnapshot), deproxyify ? JSON.parse(JSON.stringify(selfSnapshot)) : selfSnapshot);
  }
  applySnapshot(snapshot) {
    super.applySnapshot(snapshot);
    this.mode = snapshot.mode;
    this.options = snapshot.options;
  }
  get isEmpty() {
    return this.state.length === 0;
  }
  test(location) {
    if (this.matchOnEmpty && this.isEmpty) return true;
    var value = location.fields[this.fieldName];
    var locationFlags = new Set(Array.isArray(value) ? value : !!value ? [value] : []);
    if (this.mode === 'any') {
      for (var selectedFlag of this.state) {
        // location has one we want, include it
        if (locationFlags.has(selectedFlag)) return true;
      }
      // location did have any of the ones we were looking
      return false;
    } else {
      for (var _selectedFlag of this.state) {
        // location doesn't have one we cant, exclude it
        if (!locationFlags.has(_selectedFlag)) return false;
      }
      // location met all requirements, include it
      return true;
    }
  }
}
export default FlagFilter;
//# sourceMappingURL=FlagFilter.js.map